/* AFX Pro Tools — shared product lookup over the TDS data island.
   Loads assets/afx-protools-index.json once and exposes a tiny search/get API the
   standalone tools use to pull a product's REAL cure schedule, coverage unit, container
   size, application steps, and TDS / Application-Guide PDF links.

   Index shape: { v, count, products: { "<handle>": {
       t:"Title", b:"Brand",
       cure:[{k,v,icon}],   // cure_timeline  (Flash / Tape-free / Recoat / Full cure)
       cu:"cans",           // coverage_unit  (optional)
       size:"450",          // container size (optional, from spec_rows)
       how:["step",…],      // how_to_steps   (optional, <=6)
       tds:"/cdn/…​.pdf",    // TDS PDF, store-relative (optional)
       ag:"/cdn/…​.pdf"      // Application-Guide PDF (optional)
   } } }

   Usage:
     AFXProTools.load("{{ 'afx-protools-index.json' | asset_url }}")
       .then(() => { … AFXProTools.search("ppg clear"); AFXProTools.get(handle); });
   Every call is null/empty-safe: if the index fails to load, search() returns [] and the
   tool keeps working in its generic mode.
*/
(function () {
  "use strict";
  if (window.AFXProTools) return;

  var _products = null;   // handle -> record
  var _list = null;       // [{h,t,b,tl,bl}]
  var _promise = null;

  function _index(json) {
    _products = (json && json.products) || {};
    _list = Object.keys(_products).map(function (h) {
      var r = _products[h];
      return { h: h, t: r.t || h, b: r.b || "", tl: (r.t || h).toLowerCase(), bl: (r.b || "").toLowerCase() };
    });
    return _products;
  }

  function load(url) {
    if (_products) return Promise.resolve(_products);
    if (_promise) return _promise;
    _promise = fetch(url, { credentials: "omit" })
      .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .then(_index)
      .catch(function () { _index({ products: {} }); return _products; });
    return _promise;
  }

  function search(q, limit) {
    q = (q || "").trim().toLowerCase();
    if (!q || !_list) return [];
    var terms = q.split(/\s+/).filter(Boolean);
    var out = [];
    for (var i = 0; i < _list.length; i++) {
      var it = _list[i], hay = it.tl + " " + it.bl, ok = true;
      for (var t = 0; t < terms.length; t++) { if (hay.indexOf(terms[t]) === -1) { ok = false; break; } }
      if (!ok) continue;
      var s = 0;
      if (it.tl.indexOf(q) === 0) s += 3;
      else if (it.tl.indexOf(q) !== -1) s += 1.5;
      if (it.bl.indexOf(q) !== -1) s += 0.5;
      out.push({ h: it.h, t: it.t, b: it.b, s: s });
    }
    out.sort(function (a, b) { return (b.s - a.s) || (a.t.length - b.t.length); });
    return out.slice(0, limit || 8);
  }

  function get(handle) { return (_products && _products[handle]) || null; }

  function ready() { return !!_products; }

  // Real corpus size. ready() is true even when load() swallowed a fetch failure and
  // indexed an empty {} — count() distinguishes "loaded with products" from "loaded empty",
  // so callers can keep a lookup UI hidden when there is nothing to search.
  function count() { return _list ? _list.length : 0; }

  window.AFXProTools = { load: load, search: search, get: get, ready: ready, count: count };
})();
